export default __webpack_public_path__ + "static/Asset2@2x-0c814c82c6d93b3b8d6d9de05a9f47cc.png";